var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"digital-classrooms"},[_c('p',{staticClass:"digital-classrooms__link",domProps:{"innerHTML":_vm._s(_vm.$t('GoLearn.digital_classrooms_button'))},on:{"click":_vm.goLearnDigitalClassrooms}}),_c('span',{staticClass:"icon-arrow-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }